import { Link } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'
import { Button, buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import ThinkinCodeFooter from '../components/ThinkinCodeFooter'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col justify-center py-12 px-4 sm:px-6">
      <div className="mx-auto w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <img
            src="/brand/trendsetter-logo.png"
            alt=""
            className="h-16 w-auto object-contain opacity-90"
          />
        </div>
        <Card className="border-border/80 shadow-lg">
          <CardHeader className="text-center pb-2">
            <p className="text-5xl font-bold tabular-nums text-primary">404</p>
            <CardTitle className="text-xl pt-2">Page not found</CardTitle>
            <CardDescription>
              That link doesn&apos;t exist or was moved. Check the URL or go back to your dashboard.
            </CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-3 sm:flex-row sm:justify-center pb-8">
            <Link to="/" className={cn(buttonVariants(), 'inline-flex gap-2')}>
              <Home className="size-4" />
              Dashboard
            </Link>
            <Button variant="outline" type="button" onClick={() => window.history.back()}>
              <ArrowLeft className="size-4" />
              Back
            </Button>
          </CardContent>
        </Card>
        <ThinkinCodeFooter />
      </div>
    </div>
  )
}
